// Natural / human sort: "A2" < "A10" < "A100" (digit runs compared numerically).
export function naturalCompare(a: string, b: string): number {
  const re = /(\d+|\D+)/g;
  const ap = a.match(re) ?? [];
  const bp = b.match(re) ?? [];
  const n = Math.min(ap.length, bp.length);
  for (let i = 0; i < n; i++) {
    const x = ap[i];
    const y = bp[i];
    const xNum = /^\d/.test(x);
    const yNum = /^\d/.test(y);
    if (xNum && yNum) {
      const d = Number(x) - Number(y);
      if (d !== 0) return d;
    } else {
      const xl = x.toLowerCase();
      const yl = y.toLowerCase();
      if (xl !== yl) return xl < yl ? -1 : 1;
    }
  }
  return ap.length - bp.length;
}
